import { useQuery } from '@tanstack/react-query';
import { clientsApi, type ClientProfile } from './clients.api';

/**
 * Fetch a patient profile by id. Cached for 30s (matches the global
 * staleTime). Returns null-safe data: errors are surfaced via `error`,
 * not by returning undefined twice.
 */
export function useClientProfile(clientId: string | undefined) {
  return useQuery<ClientProfile>({
    queryKey: ['clients.profile', clientId],
    queryFn: () => clientsApi.getProfile(clientId as string),
    enabled: !!clientId,
  });
}
